import { InputBase, Paper } from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { colors } from 'Constants/Colors';
import { SearchTextFieldContainer, SearchTextFieldLabel } from './SearchTextField.styled';

interface Props {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  name?: string;
}
const SearchTextField = ({ label, placeholder, value, onChange, onBlur, name, ...props }: Props) => {
  return (
    <SearchTextFieldContainer>
      <SearchTextFieldLabel hidden={!label}>{label}</SearchTextFieldLabel>
      <Paper
        variant="outlined"
        sx={{ padding: '0.5rem', alignItems: 'center', display: 'flex', gap: '0.5rem', height: '50px' }}
      >
        <SearchIcon style={{ color: colors.GRAY }} />
        <InputBase
          placeholder={placeholder}
          fullWidth
          value={value || ''}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          sx={{
            height: '100%',
            '& input': {
              height: '100%',
              padding: 0,
              color: value ? 'black' : undefined,
              '&::placeholder': {
                color: colors.GRAY,
                opacity: 1,
              },
            },
          }}
          {...props}
        />
      </Paper>
    </SearchTextFieldContainer>
  );
};

export default SearchTextField;
